import { render, staticRenderFns } from "./review-card-vertical.vue?vue&type=template&id=17d33287"
import script from "./review-card-vertical.vue?vue&type=script&lang=ts"
export * from "./review-card-vertical.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports